export const formatTableList = (item) => {
  item.ctr !== undefined && (item.ctr = (item.ctr * 100).toFixed(2) + "%");
  item.activeRate !== undefined && (item.activeRate = (item.activeRate * 100).toFixed(2) + "%");
  item.convertCntRate !== undefined &&
    (item.convertCntRate = (item.convertCntRate * 100).toFixed(2) + "%");
  item.engagementConvertRate !== undefined &&
    (item.engagementConvertRate = (item.engagementConvertRate * 100).toFixed(2) + "%");
  item.allConvertRate !== undefined &&
    (item.allConvertRate = (item.allConvertRate * 100).toFixed(2) + "%");
  item.engagementRate !== undefined &&
    (item.engagementRate = (item.engagementRate * 100).toFixed(2) + "%");
  item.costPerBudget !== undefined &&
    (item.costPerBudget = (item.costPerBudget * 100).toFixed(2) + "%");

  item.dailyBudget = "$" + item.dailyBudget;
  item.cpc = "$" + item.cpc;
  item.thousandDisplayPrice = "$" + item.thousandDisplayPrice;
  item.convertCntCost = "$" + item.convertCntCost;
  item.activeCost = "$" + item.activeCost;
};
